import { type ThemeOptions, createTheme, ThemeProvider } from '@mui/material';
import React from 'react';
import { Button } from '~/components/Button';
import { Link } from '~/components/Link';
import { SnackbarProvider } from '~/providers/SnackbarProvider';

// Extend the default theme palette types
declare module '@mui/material/styles' {
  interface Palette {
    white: Palette['primary'];
  }
  interface PaletteOptions {
    white?: PaletteOptions['primary'];
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    white: true;
  }
}
declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    white: true;
  }
}
declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    white: true;
  }
}
declare module '@mui/material/AppBar' {
  interface AppBarPropsColorOverrides {
    white: true;
  }
}

export default function MuiProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  let theme = createTheme({} as ThemeOptions);
  theme = createTheme(theme, {
    palette: {
      white: theme.palette.augmentColor({
        color: { main: '#FFFFFF' },
        name: 'white',
      }),
    },
    components: {
      MuiLink: {
        defaultProps: {
          component: Link,
        },
      },
      MuiButtonBase: {
        defaultProps: {
          LinkComponent: Button,
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>{children}</SnackbarProvider>
    </ThemeProvider>
  );
}
